import { BaseManager } from '../base/manager';
import { STORE_NAMES } from '../config';

import { ILayout } from '~/ILayout';

export class LayoutManager extends BaseManager<ILayout> {
  constructor() {
    super(STORE_NAMES.layout);
  }

  protected generateKey(layout: ILayout): string {
    return layout.userKey
      ? `${layout.companyId}-${layout.userKey}-${layout.id}`
      : layout.id;
  }

  async getByUser(companyId: string, userKey: string): Promise<ILayout[]> {
    const allLayouts = await this.getAll();
    return allLayouts?.filter((layout) => layout?.companyId === companyId && layout.userKey === userKey) || [];
  }

  async saveLayout(layout: ILayout): Promise<void> {
    return this.save(layout);
  }

  async getLayout(key: string): Promise<ILayout | undefined> {
    return this.get(key);
  }

  async deleteLayout(key: string): Promise<void> {
    return this.delete(key);
  }

  async getAllLayouts(companyId: string, userKey: string): Promise<ILayout[]> {
    return this.getByUser(companyId, userKey);
  }
}

// Export singleton instance
export const indexedDbLayoutManager = new LayoutManager();
